/*=========================================================================================
  File Name: actions.js
  Description: Vuex Store - actions
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/


// /////////////////////////////////////////////
// COMPONENTS
// /////////////////////////////////////////////

// Vertical NavMenu
export function updateVerticalNavMenuWidth ({ commit }, width) {
  commit('UPDATE_VERTICAL_NAV_MENU_WIDTH', width)
}


// VxAutoSuggest
export function updateStarredPage ({ commit }, payload) {
  commit('UPDATE_STARRED_PAGE', payload)
}


// The Navbar
export function arrangeStarredPagesLimited ({ commit }, list) {
  commit('ARRANGE_STARRED_PAGES_LIMITED', list)
}

export function arrangeStarredPagesMore ({ commit }, list) {
  commit('ARRANGE_STARRED_PAGES_MORE', list)
}
